/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const deleteSubject = /* GraphQL */ `
  mutation DeleteSubject(
    $input: DeleteSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    deleteSubject(input: $input, condition: $condition) {
      id
      grade
      subject
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherAssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTeacherProfile = /* GraphQL */ `
  mutation DeleteTeacherProfile(
    $input: DeleteTeacherProfileInput!
    $condition: ModelTeacherProfileConditionInput
  ) {
    deleteTeacherProfile(input: $input, condition: $condition) {
      id
      title
      name
      surname
      language
      province
      daysPerWeek
      status
      TeacherSchedules {
        nextToken
        startedAt
        __typename
      }
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      TeacherProductsOrders {
        nextToken
        startedAt
        __typename
      }
      School {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      payfastSubscriptionToken
      sessionToken
      productsOrderShippingDetails
      products
      payfastSubscriptionResponse
      productSubscriptions
      payfastSubscriptionPackage
      translateI18n
      type
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      teacherProfileSchoolId
      __typename
    }
  }
`;
export const createCoupon = /* GraphQL */ `
  mutation CreateCoupon(
    $input: CreateCouponInput!
    $condition: ModelCouponConditionInput
  ) {
    createCoupon(input: $input, condition: $condition) {
      id
      restrictTo
      startDate
      endDate
      discount
      enabled
      couponCode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCoupon = /* GraphQL */ `
  mutation UpdateCoupon(
    $input: UpdateCouponInput!
    $condition: ModelCouponConditionInput
  ) {
    updateCoupon(input: $input, condition: $condition) {
      id
      restrictTo
      startDate
      endDate
      discount
      enabled
      couponCode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCoupon = /* GraphQL */ `
  mutation DeleteCoupon(
    $input: DeleteCouponInput!
    $condition: ModelCouponConditionInput
  ) {
    deleteCoupon(input: $input, condition: $condition) {
      id
      restrictTo
      startDate
      endDate
      discount
      enabled
      couponCode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSecret = /* GraphQL */ `
  mutation CreateSecret(
    $input: CreateSecretInput!
    $condition: ModelSecretConditionInput
  ) {
    createSecret(input: $input, condition: $condition) {
      id
      type
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSecret = /* GraphQL */ `
  mutation UpdateSecret(
    $input: UpdateSecretInput!
    $condition: ModelSecretConditionInput
  ) {
    updateSecret(input: $input, condition: $condition) {
      id
      type
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSecret = /* GraphQL */ `
  mutation DeleteSecret(
    $input: DeleteSecretInput!
    $condition: ModelSecretConditionInput
  ) {
    deleteSecret(input: $input, condition: $condition) {
      id
      type
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createAnnouncement = /* GraphQL */ `
  mutation CreateAnnouncement(
    $input: CreateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    createAnnouncement(input: $input, condition: $condition) {
      id
      title
      sendTo
      readBy
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateAnnouncement = /* GraphQL */ `
  mutation UpdateAnnouncement(
    $input: UpdateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    updateAnnouncement(input: $input, condition: $condition) {
      id
      title
      sendTo
      readBy
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteAnnouncement = /* GraphQL */ `
  mutation DeleteAnnouncement(
    $input: DeleteAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    deleteAnnouncement(input: $input, condition: $condition) {
      id
      title
      sendTo
      readBy
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCommunication = /* GraphQL */ `
  mutation CreateCommunication(
    $input: CreateCommunicationInput!
    $condition: ModelCommunicationConditionInput
  ) {
    createCommunication(input: $input, condition: $condition) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCommunication = /* GraphQL */ `
  mutation UpdateCommunication(
    $input: UpdateCommunicationInput!
    $condition: ModelCommunicationConditionInput
  ) {
    updateCommunication(input: $input, condition: $condition) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCommunication = /* GraphQL */ `
  mutation DeleteCommunication(
    $input: DeleteCommunicationInput!
    $condition: ModelCommunicationConditionInput
  ) {
    deleteCommunication(input: $input, condition: $condition) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTeacherProductsOrder = /* GraphQL */ `
  mutation CreateTeacherProductsOrder(
    $input: CreateTeacherProductsOrderInput!
    $condition: ModelTeacherProductsOrderConditionInput
  ) {
    createTeacherProductsOrder(input: $input, condition: $condition) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTeacherProductsOrder = /* GraphQL */ `
  mutation UpdateTeacherProductsOrder(
    $input: UpdateTeacherProductsOrderInput!
    $condition: ModelTeacherProductsOrderConditionInput
  ) {
    updateTeacherProductsOrder(input: $input, condition: $condition) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTeacherProductsOrder = /* GraphQL */ `
  mutation DeleteTeacherProductsOrder(
    $input: DeleteTeacherProductsOrderInput!
    $condition: ModelTeacherProductsOrderConditionInput
  ) {
    deleteTeacherProductsOrder(input: $input, condition: $condition) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createArchivedTeacherProductsOrder = /* GraphQL */ `
  mutation CreateArchivedTeacherProductsOrder(
    $input: CreateArchivedTeacherProductsOrderInput!
    $condition: ModelArchivedTeacherProductsOrderConditionInput
  ) {
    createArchivedTeacherProductsOrder(input: $input, condition: $condition) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateArchivedTeacherProductsOrder = /* GraphQL */ `
  mutation UpdateArchivedTeacherProductsOrder(
    $input: UpdateArchivedTeacherProductsOrderInput!
    $condition: ModelArchivedTeacherProductsOrderConditionInput
  ) {
    updateArchivedTeacherProductsOrder(input: $input, condition: $condition) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteArchivedTeacherProductsOrder = /* GraphQL */ `
  mutation DeleteArchivedTeacherProductsOrder(
    $input: DeleteArchivedTeacherProductsOrderInput!
    $condition: ModelArchivedTeacherProductsOrderConditionInput
  ) {
    deleteArchivedTeacherProductsOrder(input: $input, condition: $condition) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createProductCategory = /* GraphQL */ `
  mutation CreateProductCategory(
    $input: CreateProductCategoryInput!
    $condition: ModelProductCategoryConditionInput
  ) {
    createProductCategory(input: $input, condition: $condition) {
      id
      name
      slug
      parentId
      grade
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateProductCategory = /* GraphQL */ `
  mutation UpdateProductCategory(
    $input: UpdateProductCategoryInput!
    $condition: ModelProductCategoryConditionInput
  ) {
    updateProductCategory(input: $input, condition: $condition) {
      id
      name
      slug
      parentId
      grade
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteProductCategory = /* GraphQL */ `
  mutation DeleteProductCategory(
    $input: DeleteProductCategoryInput!
    $condition: ModelProductCategoryConditionInput
  ) {
    deleteProductCategory(input: $input, condition: $condition) {
      id
      name
      slug
      parentId
      grade
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createProductTag = /* GraphQL */ `
  mutation CreateProductTag(
    $input: CreateProductTagInput!
    $condition: ModelProductTagConditionInput
  ) {
    createProductTag(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateProductTag = /* GraphQL */ `
  mutation UpdateProductTag(
    $input: UpdateProductTagInput!
    $condition: ModelProductTagConditionInput
  ) {
    updateProductTag(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteProductTag = /* GraphQL */ `
  mutation DeleteProductTag(
    $input: DeleteProductTagInput!
    $condition: ModelProductTagConditionInput
  ) {
    deleteProductTag(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createProductContent = /* GraphQL */ `
  mutation CreateProductContent(
    $input: CreateProductContentInput!
    $condition: ModelProductContentConditionInput
  ) {
    createProductContent(input: $input, condition: $condition) {
      id
      productId
      fileKeys
      urls
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateProductContent = /* GraphQL */ `
  mutation UpdateProductContent(
    $input: UpdateProductContentInput!
    $condition: ModelProductContentConditionInput
  ) {
    updateProductContent(input: $input, condition: $condition) {
      id
      productId
      fileKeys
      urls
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteProductContent = /* GraphQL */ `
  mutation DeleteProductContent(
    $input: DeleteProductContentInput!
    $condition: ModelProductContentConditionInput
  ) {
    deleteProductContent(input: $input, condition: $condition) {
      id
      productId
      fileKeys
      urls
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createProductBundle = /* GraphQL */ `
  mutation CreateProductBundle(
    $input: CreateProductBundleInput!
    $condition: ModelProductBundleConditionInput
  ) {
    createProductBundle(input: $input, condition: $condition) {
      id
      title
      description
      price
      discountPercentage
      thumbnails
      products
      tags
      publishDate
      featured
      searchField
      categoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateProductBundle = /* GraphQL */ `
  mutation UpdateProductBundle(
    $input: UpdateProductBundleInput!
    $condition: ModelProductBundleConditionInput
  ) {
    updateProductBundle(input: $input, condition: $condition) {
      id
      title
      description
      price
      discountPercentage
      thumbnails
      products
      tags
      publishDate
      featured
      searchField
      categoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteProductBundle = /* GraphQL */ `
  mutation DeleteProductBundle(
    $input: DeleteProductBundleInput!
    $condition: ModelProductBundleConditionInput
  ) {
    deleteProductBundle(input: $input, condition: $condition) {
      id
      title
      description
      price
      discountPercentage
      thumbnails
      products
      tags
      publishDate
      featured
      searchField
      categoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      title
      description
      price
      discountPercentage
      eCommerceProduct
      subscriptionProduct
      thumbnails
      tags
      publishDate
      featured
      physical
      searchField
      categoryId
      questions
      sku
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      title
      description
      price
      discountPercentage
      eCommerceProduct
      subscriptionProduct
      thumbnails
      tags
      publishDate
      featured
      physical
      searchField
      categoryId
      questions
      sku
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      title
      description
      price
      discountPercentage
      eCommerceProduct
      subscriptionProduct
      thumbnails
      tags
      publishDate
      featured
      physical
      searchField
      categoryId
      questions
      sku
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTaxonomy = /* GraphQL */ `
  mutation CreateTaxonomy(
    $input: CreateTaxonomyInput!
    $condition: ModelTaxonomyConditionInput
  ) {
    createTaxonomy(input: $input, condition: $condition) {
      id
      name
      cognitiveLevels {
        label
        percentage
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTaxonomy = /* GraphQL */ `
  mutation UpdateTaxonomy(
    $input: UpdateTaxonomyInput!
    $condition: ModelTaxonomyConditionInput
  ) {
    updateTaxonomy(input: $input, condition: $condition) {
      id
      name
      cognitiveLevels {
        label
        percentage
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTaxonomy = /* GraphQL */ `
  mutation DeleteTaxonomy(
    $input: DeleteTaxonomyInput!
    $condition: ModelTaxonomyConditionInput
  ) {
    deleteTaxonomy(input: $input, condition: $condition) {
      id
      name
      cognitiveLevels {
        label
        percentage
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTeacherAssessmentTemplate = /* GraphQL */ `
  mutation CreateTeacherAssessmentTemplate(
    $input: CreateTeacherAssessmentTemplateInput!
    $condition: ModelTeacherAssessmentTemplateConditionInput
  ) {
    createTeacherAssessmentTemplate(input: $input, condition: $condition) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      instructions
      taxonomy
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateTeacherAssessmentTemplate = /* GraphQL */ `
  mutation UpdateTeacherAssessmentTemplate(
    $input: UpdateTeacherAssessmentTemplateInput!
    $condition: ModelTeacherAssessmentTemplateConditionInput
  ) {
    updateTeacherAssessmentTemplate(input: $input, condition: $condition) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      instructions
      taxonomy
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteTeacherAssessmentTemplate = /* GraphQL */ `
  mutation DeleteTeacherAssessmentTemplate(
    $input: DeleteTeacherAssessmentTemplateInput!
    $condition: ModelTeacherAssessmentTemplateConditionInput
  ) {
    deleteTeacherAssessmentTemplate(input: $input, condition: $condition) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      instructions
      taxonomy
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createAssessmentTemplate = /* GraphQL */ `
  mutation CreateAssessmentTemplate(
    $input: CreateAssessmentTemplateInput!
    $condition: ModelAssessmentTemplateConditionInput
  ) {
    createAssessmentTemplate(input: $input, condition: $condition) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      instructions
      taxonomys
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateAssessmentTemplate = /* GraphQL */ `
  mutation UpdateAssessmentTemplate(
    $input: UpdateAssessmentTemplateInput!
    $condition: ModelAssessmentTemplateConditionInput
  ) {
    updateAssessmentTemplate(input: $input, condition: $condition) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      instructions
      taxonomys
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteAssessmentTemplate = /* GraphQL */ `
  mutation DeleteAssessmentTemplate(
    $input: DeleteAssessmentTemplateInput!
    $condition: ModelAssessmentTemplateConditionInput
  ) {
    deleteAssessmentTemplate(input: $input, condition: $condition) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      instructions
      taxonomys
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTeacherSubjectTemplate = /* GraphQL */ `
  mutation CreateTeacherSubjectTemplate(
    $input: CreateTeacherSubjectTemplateInput!
    $condition: ModelTeacherSubjectTemplateConditionInput
  ) {
    createTeacherSubjectTemplate(input: $input, condition: $condition) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateTeacherSubjectTemplate = /* GraphQL */ `
  mutation UpdateTeacherSubjectTemplate(
    $input: UpdateTeacherSubjectTemplateInput!
    $condition: ModelTeacherSubjectTemplateConditionInput
  ) {
    updateTeacherSubjectTemplate(input: $input, condition: $condition) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteTeacherSubjectTemplate = /* GraphQL */ `
  mutation DeleteTeacherSubjectTemplate(
    $input: DeleteTeacherSubjectTemplateInput!
    $condition: ModelTeacherSubjectTemplateConditionInput
  ) {
    deleteTeacherSubjectTemplate(input: $input, condition: $condition) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createSubjectTemplate = /* GraphQL */ `
  mutation CreateSubjectTemplate(
    $input: CreateSubjectTemplateInput!
    $condition: ModelSubjectTemplateConditionInput
  ) {
    createSubjectTemplate(input: $input, condition: $condition) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      subjectID
      schoolID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSubjectTemplate = /* GraphQL */ `
  mutation UpdateSubjectTemplate(
    $input: UpdateSubjectTemplateInput!
    $condition: ModelSubjectTemplateConditionInput
  ) {
    updateSubjectTemplate(input: $input, condition: $condition) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      subjectID
      schoolID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSubjectTemplate = /* GraphQL */ `
  mutation DeleteSubjectTemplate(
    $input: DeleteSubjectTemplateInput!
    $condition: ModelSubjectTemplateConditionInput
  ) {
    deleteSubjectTemplate(input: $input, condition: $condition) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      subjectID
      schoolID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSchool = /* GraphQL */ `
  mutation CreateSchool(
    $input: CreateSchoolInput!
    $condition: ModelSchoolConditionInput
  ) {
    createSchool(input: $input, condition: $condition) {
      id
      name
      provinces
      isGeneric
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      schoolImgKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSchool = /* GraphQL */ `
  mutation UpdateSchool(
    $input: UpdateSchoolInput!
    $condition: ModelSchoolConditionInput
  ) {
    updateSchool(input: $input, condition: $condition) {
      id
      name
      provinces
      isGeneric
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      schoolImgKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSchool = /* GraphQL */ `
  mutation DeleteSchool(
    $input: DeleteSchoolInput!
    $condition: ModelSchoolConditionInput
  ) {
    deleteSchool(input: $input, condition: $condition) {
      id
      name
      provinces
      isGeneric
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      schoolImgKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTeacherActivity = /* GraphQL */ `
  mutation CreateTeacherActivity(
    $input: CreateTeacherActivityInput!
    $condition: ModelTeacherActivityConditionInput
  ) {
    createTeacherActivity(input: $input, condition: $condition) {
      id
      label
      type
      endDateTime
      color
      teacherprofileID
      teachersubjecttemplateID
      teacherassessmenttemplateID
      startDateTime
      repeatID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateTeacherActivity = /* GraphQL */ `
  mutation UpdateTeacherActivity(
    $input: UpdateTeacherActivityInput!
    $condition: ModelTeacherActivityConditionInput
  ) {
    updateTeacherActivity(input: $input, condition: $condition) {
      id
      label
      type
      endDateTime
      color
      teacherprofileID
      teachersubjecttemplateID
      teacherassessmenttemplateID
      startDateTime
      repeatID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteTeacherActivity = /* GraphQL */ `
  mutation DeleteTeacherActivity(
    $input: DeleteTeacherActivityInput!
    $condition: ModelTeacherActivityConditionInput
  ) {
    deleteTeacherActivity(input: $input, condition: $condition) {
      id
      label
      type
      endDateTime
      color
      teacherprofileID
      teachersubjecttemplateID
      teacherassessmenttemplateID
      startDateTime
      repeatID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createTerm = /* GraphQL */ `
  mutation CreateTerm(
    $input: CreateTermInput!
    $condition: ModelTermConditionInput
  ) {
    createTerm(input: $input, condition: $condition) {
      id
      label
      start
      end
      biweeks {
        label
        start
        end
        color
        __typename
      }
      provinces
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTerm = /* GraphQL */ `
  mutation UpdateTerm(
    $input: UpdateTermInput!
    $condition: ModelTermConditionInput
  ) {
    updateTerm(input: $input, condition: $condition) {
      id
      label
      start
      end
      biweeks {
        label
        start
        end
        color
        __typename
      }
      provinces
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTerm = /* GraphQL */ `
  mutation DeleteTerm(
    $input: DeleteTermInput!
    $condition: ModelTermConditionInput
  ) {
    deleteTerm(input: $input, condition: $condition) {
      id
      label
      start
      end
      biweeks {
        label
        start
        end
        color
        __typename
      }
      provinces
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createHoliday = /* GraphQL */ `
  mutation CreateHoliday(
    $input: CreateHolidayInput!
    $condition: ModelHolidayConditionInput
  ) {
    createHoliday(input: $input, condition: $condition) {
      id
      label
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateHoliday = /* GraphQL */ `
  mutation UpdateHoliday(
    $input: UpdateHolidayInput!
    $condition: ModelHolidayConditionInput
  ) {
    updateHoliday(input: $input, condition: $condition) {
      id
      label
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteHoliday = /* GraphQL */ `
  mutation DeleteHoliday(
    $input: DeleteHolidayInput!
    $condition: ModelHolidayConditionInput
  ) {
    deleteHoliday(input: $input, condition: $condition) {
      id
      label
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTeacherClassSubject = /* GraphQL */ `
  mutation CreateTeacherClassSubject(
    $input: CreateTeacherClassSubjectInput!
    $condition: ModelTeacherClassSubjectConditionInput
  ) {
    createTeacherClassSubject(input: $input, condition: $condition) {
      id
      name
      teacherprofileID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateTeacherClassSubject = /* GraphQL */ `
  mutation UpdateTeacherClassSubject(
    $input: UpdateTeacherClassSubjectInput!
    $condition: ModelTeacherClassSubjectConditionInput
  ) {
    updateTeacherClassSubject(input: $input, condition: $condition) {
      id
      name
      teacherprofileID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteTeacherClassSubject = /* GraphQL */ `
  mutation DeleteTeacherClassSubject(
    $input: DeleteTeacherClassSubjectInput!
    $condition: ModelTeacherClassSubjectConditionInput
  ) {
    deleteTeacherClassSubject(input: $input, condition: $condition) {
      id
      name
      teacherprofileID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createSubject = /* GraphQL */ `
  mutation CreateSubject(
    $input: CreateSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    createSubject(input: $input, condition: $condition) {
      id
      grade
      subject
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherAssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSubject = /* GraphQL */ `
  mutation UpdateSubject(
    $input: UpdateSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    updateSubject(input: $input, condition: $condition) {
      id
      grade
      subject
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherAssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTeacherSchedule = /* GraphQL */ `
  mutation CreateTeacherSchedule(
    $input: CreateTeacherScheduleInput!
    $condition: ModelTeacherScheduleConditionInput
  ) {
    createTeacherSchedule(input: $input, condition: $condition) {
      id
      day
      periods
      periodDuration
      breakDurations
      startTime
      endTime
      teacherprofileID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateTeacherSchedule = /* GraphQL */ `
  mutation UpdateTeacherSchedule(
    $input: UpdateTeacherScheduleInput!
    $condition: ModelTeacherScheduleConditionInput
  ) {
    updateTeacherSchedule(input: $input, condition: $condition) {
      id
      day
      periods
      periodDuration
      breakDurations
      startTime
      endTime
      teacherprofileID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteTeacherSchedule = /* GraphQL */ `
  mutation DeleteTeacherSchedule(
    $input: DeleteTeacherScheduleInput!
    $condition: ModelTeacherScheduleConditionInput
  ) {
    deleteTeacherSchedule(input: $input, condition: $condition) {
      id
      day
      periods
      periodDuration
      breakDurations
      startTime
      endTime
      teacherprofileID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createReportingTeacher = /* GraphQL */ `
  mutation CreateReportingTeacher(
    $input: CreateReportingTeacherInput!
    $condition: ModelReportingTeacherConditionInput
  ) {
    createReportingTeacher(input: $input, condition: $condition) {
      id
      title
      name
      surname
      language
      province
      email
      phone
      registrationDate
      roles
      productCount
      teacherprofileID
      teacherProfileSchoolId
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateReportingTeacher = /* GraphQL */ `
  mutation UpdateReportingTeacher(
    $input: UpdateReportingTeacherInput!
    $condition: ModelReportingTeacherConditionInput
  ) {
    updateReportingTeacher(input: $input, condition: $condition) {
      id
      title
      name
      surname
      language
      province
      email
      phone
      registrationDate
      roles
      productCount
      teacherprofileID
      teacherProfileSchoolId
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteReportingTeacher = /* GraphQL */ `
  mutation DeleteReportingTeacher(
    $input: DeleteReportingTeacherInput!
    $condition: ModelReportingTeacherConditionInput
  ) {
    deleteReportingTeacher(input: $input, condition: $condition) {
      id
      title
      name
      surname
      language
      province
      email
      phone
      registrationDate
      roles
      productCount
      teacherprofileID
      teacherProfileSchoolId
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTeacherProfile = /* GraphQL */ `
  mutation CreateTeacherProfile(
    $input: CreateTeacherProfileInput!
    $condition: ModelTeacherProfileConditionInput
  ) {
    createTeacherProfile(input: $input, condition: $condition) {
      id
      title
      name
      surname
      language
      province
      daysPerWeek
      status
      TeacherSchedules {
        nextToken
        startedAt
        __typename
      }
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      TeacherProductsOrders {
        nextToken
        startedAt
        __typename
      }
      School {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      payfastSubscriptionToken
      sessionToken
      productsOrderShippingDetails
      products
      payfastSubscriptionResponse
      productSubscriptions
      payfastSubscriptionPackage
      translateI18n
      type
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      teacherProfileSchoolId
      __typename
    }
  }
`;
export const updateTeacherProfile = /* GraphQL */ `
  mutation UpdateTeacherProfile(
    $input: UpdateTeacherProfileInput!
    $condition: ModelTeacherProfileConditionInput
  ) {
    updateTeacherProfile(input: $input, condition: $condition) {
      id
      title
      name
      surname
      language
      province
      daysPerWeek
      status
      TeacherSchedules {
        nextToken
        startedAt
        __typename
      }
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      TeacherProductsOrders {
        nextToken
        startedAt
        __typename
      }
      School {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      payfastSubscriptionToken
      sessionToken
      productsOrderShippingDetails
      products
      payfastSubscriptionResponse
      productSubscriptions
      payfastSubscriptionPackage
      translateI18n
      type
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      teacherProfileSchoolId
      __typename
    }
  }
`;
